import { stringifyQueryString } from '~/utils/string';

export const jobberInitiateUrl = (teamId: number, groupId?: string | null): string => {
    const base = `/teams/${teamId}/integrations/jobber/oauth/initiate`;

    return groupId ? `${base}?${stringifyQueryString({ group: groupId })}` : base;
};
